import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Search, FileText, Handshake, DollarSign, ArrowRight } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Process() {
  const {
    t
  } = useLanguage();
  const icons = [Search, FileText, Handshake, DollarSign];
  return <section id="process" className="py-24 bg-brand-dark text-white" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-209">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-brand-gold font-bold tracking-wider uppercase mb-2" data-id="element-210">
            {t.process.tag}
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-black mb-6" data-id="element-211">
            {t.process.title}
          </motion.h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-212">
          {/* Connecting Line for Desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-brand-red/30 z-0" data-id="element-213"></div>

          {t.process.steps.map((step, index) => {
          const Icon = icons[index];
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="relative z-10 flex flex-col items-center text-center" data-id="element-214">
                <div className="w-24 h-24 bg-brand-dark border-4 border-brand-red rounded-full flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(220,38,38,0.3)]" data-id="element-215">
                  <Icon className="text-brand-gold" size={40} data-id="element-216" />
                </div>
                {index === 0 ? <Link to="/free-inspection" className="bg-white/5 p-6 rounded-sm border border-white/10 w-full h-full block hover:bg-white/10 hover:border-brand-gold/30 transition-all group" data-id="element-217">
                    <div className="text-brand-red font-black text-xl mb-2" data-id="element-218">
                      {t.process.step} {index + 1}
                    </div>
                    <h4 className="text-2xl font-bold mb-3" data-id="element-219">{step.title}</h4>
                    <p className="text-gray-400 leading-relaxed" data-id="element-220">{step.desc}</p>
                    <div className="mt-4 inline-flex items-center gap-2 text-brand-gold font-bold text-sm uppercase tracking-wider group-hover:gap-3 transition-all" data-id="element-221">
                      {t.process.learnMore} <ArrowRight size={16} data-id="element-222" />
                    </div>
                  </Link> : <div className="bg-white/5 p-6 rounded-sm border border-white/10 w-full h-full" data-id="element-223">
                    <div className="text-brand-red font-black text-xl mb-2" data-id="element-224">
                      {t.process.step} {index + 1}
                    </div>
                    <h4 className="text-2xl font-bold mb-3" data-id="element-225">{step.title}</h4>
                    <p className="text-gray-400 leading-relaxed" data-id="element-226">{step.desc}</p>
                  </div>}
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}